export const FREE_CTA_DATA_TEST = 'try-free-button'
